import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import {
  AUTOMATION_SCHEDULES_QUERY_KEY,
  AutomationSchedule
} from "./useFetchAutomationSchedules";

interface CreateScheduleRequest {
  name: string;
  automationId: string;
  schedule: {
    type: "once" | "daily" | "weekly" | "monthly";
    startDate: string;
    endDate?: string;
    time?: string;
    dayOfWeek?: number;
    dayOfMonth?: number;
  };
  emailTemplate?: {
    subject: string;
    body: string;
    recipients: string[];
  };
  isActive?: boolean;
}

const createAutomationSchedule = async (
  scheduleData: CreateScheduleRequest
): Promise<AutomationSchedule> => {
  const response = await axios.post<AutomationSchedule>(
    `${AUTOMATION_SERVICE_ADDRESS}/api/schedules`,
    scheduleData
  );
  return response.data;
};

export default function useCreateAutomationSchedule() {
  const queryClient = useQueryClient();

  return useMutation(createAutomationSchedule, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_SCHEDULES_QUERY_KEY);
    }
  });
}
